package com.gastoncantera.intercom

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.apps
import dev.gitlive.firebase.initialize
import kotlinx.browser.window
import kotlin.js.json

/**
 * En web Firebase no se auto-inicializa (no hay google-services.json / plist), así que hay que
 * llamar a [Firebase.initialize] antes de usar Auth/Firestore/Remote Config. En Android/iOS esto
 * lo hace el SDK nativo solo, por eso vive únicamente en jsMain.
 *
 * La config vive en un único lugar: `firebase-config.js` (cargado por index.html antes del bundle),
 * que define `window.FIREBASE_CONFIG`. Así no se repite en el shim de FCM ni en el service worker.
 *
 * App Check tiene que activarse en **esta** instancia (GitLive / `firebase/app` del bundle). El
 * compat del CDN es otro Firebase: activar App Check ahí no cubre Firestore/Auth de la app.
 */
fun initializeFirebase() {
    if (Firebase.apps().isEmpty()) {
        val cfg = window.asDynamic().FIREBASE_CONFIG
        Firebase.initialize(
            options = FirebaseOptions(
                applicationId = cfg.appId as String,
                apiKey = cfg.apiKey as String,
                projectId = cfg.projectId as String,
                storageBucket = cfg.storageBucket as String,
                gcmSenderId = cfg.messagingSenderId as String,
                authDomain = cfg.authDomain as String,
            ),
        )
    }
    activateAppCheck()
}

private fun activateAppCheck() {
    val siteKey = window.asDynamic().FIREBASE_APPCHECK_SITE_KEY as? String
    if (siteKey.isNullOrBlank()) {
        println("[app-check] Falta FIREBASE_APPCHECK_SITE_KEY")
        return
    }
    val host = window.location.hostname
    if (host == "localhost" || host == "127.0.0.1") {
        // Antes de initializeAppCheck. En consola aparece el UUID para App Check → Web → debug tokens.
        window.asDynamic().FIREBASE_APPCHECK_DEBUG_TOKEN = true
    }
    try {
        initializeAppCheck(
            firebaseGetApp(),
            json(
                "provider" to ReCaptchaV3Provider(siteKey),
                "isTokenAutoRefreshEnabled" to true,
            ),
        )
    } catch (_: Throwable) {
        // HMR: ya estaba inicializado en esta app.
    }
}
